import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { Search, Close } from '@mui/icons-material';
import { Grid, InputAdornment, MenuItem, TextField } from '@mui/material';
import { FC } from 'react';
import { FiltersButtons, FiltersLayout, SMBSelect } from '../../../../components';
import { IDropdownResponse } from '../../../../models';

interface IManageToolsFilters {
  isLoading: boolean;
  applyFilters: (clearFilters?: boolean) => void;
  setPage: (val: number) => void;
  setHasAppliedFilters: (val: boolean) => void;
  hasAppliedFilters?: boolean;
  searchName: string;
  setSearchName: (val: any) => void;
  handleNameSearch: (clearSearch?: boolean) => void;
  setSelectedPhase?: React.Dispatch<React.SetStateAction<string>>;
  selectedPhase?: string | number;
  setSelectedCategory?: React.Dispatch<React.SetStateAction<string>>;
  selectedCategory?: string | number;
  phases: IDropdownResponse[];
  isLoadingPhases: boolean;
  categories: IDropdownResponse[];
  isLoadingCategories: boolean;
}

export const ManageToolsFilter: FC<IManageToolsFilters> = ({
  hasAppliedFilters,
  setHasAppliedFilters,
  isLoading,
  applyFilters,
  searchName,
  setSearchName,
  handleNameSearch,
  setSelectedPhase,
  selectedPhase,
  setSelectedCategory,
  selectedCategory,
  phases,
  isLoadingPhases,
  categories,
  isLoadingCategories
}) => {
  const classes = useStyles();

  return (
    <FiltersLayout>
      <Grid item xs={4} md={4} lg={3}>
        <TextField
          size="small"
          fullWidth
          variant="outlined"
          placeholder="Search Name..."
          name="nameSearch"
          value={searchName}
          disabled={isLoading}
          InputProps={{
            startAdornment: (
              <InputAdornment
                position="start"
                className={classes.searchIcon}
                onClick={() => {
                  if (searchName.length > 0) {
                    setHasAppliedFilters(true);
                    handleNameSearch();
                  }
                }}
              >
                <Search />
              </InputAdornment>
            ),
            endAdornment: searchName ? (
              <InputAdornment
                position="end"
                className={classes.searchIcon}
                onClick={() => {
                  setHasAppliedFilters(false);
                  setSearchName('');
                  handleNameSearch(true);
                  applyFilters(true);
                }}
              >
                <Close />
              </InputAdornment>
            ) : null
          }}
          onKeyDown={e => {
            if (e.key === 'Enter' && searchName.length > 0) {
              setHasAppliedFilters(true);
              handleNameSearch();
            }
          }}
          onChange={e => {
            setSearchName(e.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} xl={3}>
        <SMBSelect
          variant="outlined"
          handleClear={() => {
            setSelectedPhase('');
          }}
          name={`phase`}
          id={`phase`}
          label="Phase"
          value={selectedPhase}
          disabled={isLoadingPhases}
          onChange={event => {
            setSelectedPhase(event.target.value);
          }}
        >
          {phases?.map((phase, index) => {
            return (
              <MenuItem key={`${index}`} value={phase.value}>
                {phase.description}
              </MenuItem>
            );
          })}
        </SMBSelect>
      </Grid>
      <Grid item xs={12} sm={6} md={4} xl={3}>
        <SMBSelect
          variant="outlined"
          handleClear={() => {
            setSelectedCategory('');
          }}
          name={`emailType`}
          id={`emailType`}
          label="Category"
          value={selectedCategory}
          disabled={isLoadingCategories}
          onChange={event => {
            setSelectedCategory(event.target.value);
          }}
        >
          {categories?.map((category, index) => {
            return (
              <MenuItem key={`${index}`} value={category.value}>
                {category.description}
              </MenuItem>
            );
          })}
        </SMBSelect>
      </Grid>
      <Grid item xs={5} lg={5}>
        <FiltersButtons
          hasAppliedFilters={hasAppliedFilters}
          isDisabled={isLoading}
          handleApplyFilters={() => {
            setHasAppliedFilters(true);
            handleNameSearch();
            applyFilters();
          }}
          handleResetFilters={() => {
            setHasAppliedFilters(false);
            setSearchName('');
            handleNameSearch(true);
            applyFilters(true);
            setSelectedPhase('');
            setSelectedCategory('');
          }}
        />
      </Grid>
    </FiltersLayout>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  searchIcon: {
    cursor: 'pointer',
    color: theme.palette.grey[500]
  }
}));
